<template>
  <div class="order-cancel">
    <div class="feedback">
      <transition name="fade" @enter="enterSuccessFeedback">
        <FeedbackSuccess
          v-if="showableSuccessFeedback"
          :message="noticeMessage"
        />
      </transition>
    </div>
    <div class="white-area order-cancel__container">
      <div class="content-inner-area">
        <div class="order-cancel__title">
          <p class="subhead-bold">
            決済をキャンセルしました
          </p>
        </div>
        <ToAppArea @click-app-button="onClickAppButton">
          お手数ですが下記のボタンから、gifteeアプリにお戻りいただき改めて決済をお願いいたします。
        </ToAppArea>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import FeedbackSuccess from '../../atoms/feedbacks/feedback-success.vue'
import ToAppArea from '../../organism/orders/ToAppArea.vue'

const showableSuccessFeedback = ref(false)

const props = defineProps({
  noticeMessage: {
    type: String,
    required: false,
    default: ''
  },
  deepLink: {
    type: String,
    required: true
  }
})

onMounted(() => {
  showableSuccessFeedback.value = props.noticeMessage.length !== 0
})

const onClickAppButton = () => {
  window.location.href = props.deepLink
}

const enterSuccessFeedback = () => {
  setTimeout(() => {
    showableSuccessFeedback.value = false
  }, 3000)
}
</script>

<style lang="scss" scoped>
.order-cancel {
  &__container {
    padding: 56px 16px;
  }

  &__title {
    margin-bottom: 24px;
  }
}
</style>
